import React, { Fragment, useContext } from "react";
import Sticky from "react-stickynode";
import TituloSection from "./tituloSection";
import PreciosSection from "./preciosSection";
import DetalleCompraSection from "./detalleCompraSection";
import { CdrGlobalContext } from "../../../../context/cdrGlobalContext";
import { calcularInfoas } from "../../../../utils/Tools";

const FichaReserva = (props) => {
  const [state] = useContext(CdrGlobalContext);
  const {
    productoSeleccionado,
    regimenSeleccionado,
    busquedaCDR,
    pasajerosAdultos,
    pasajerosMenores,
    totalCompra,
    totalRegimen,
    totalSeguroCancelacion,
    intereses,
  } = state;

  if (totalCompra === 0) return <Fragment></Fragment>;

  const infoas = calcularInfoas(pasajerosMenores);
  const pasajerosPagantes = pasajerosAdultos.length + pasajerosMenores.length - infoas;

  return (
    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 aside">
      <Sticky enabled={true} top={0} innerZ="99">
        <div className="sidebar">
          <div className="heading checkoutCdr sidebar__inner">
            <TituloSection producto={productoSeleccionado} />
            <DetalleCompraSection
              producto={productoSeleccionado}
              busquedaCDR={busquedaCDR}
              pasajerosAdultos={pasajerosAdultos}
              pasajerosMenores={pasajerosMenores}
              infoas={infoas}
              pasajerosPagantes={pasajerosPagantes}
            />
            <PreciosSection
              producto={productoSeleccionado}
              totalSeguroCancelacion={totalSeguroCancelacion}
              regimenSeleccionado={regimenSeleccionado}
              totalRegimen={totalRegimen}
              intereses={intereses}
              totalCompra={totalCompra}
            />
          </div>
        </div>
      </Sticky>
    </div>
  );
};

export default FichaReserva;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/FichaReservaCdr/index.js